import { render } from "./LinkList.vue?vue&type=template&id=13013cec&lang=pug"
import script from "./LinkList.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkList.vue?vue&type=script&setup=true&lang=js"

import "./LinkList.vue?vue&type=style&index=0&id=13013cec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__